module.exports = __webpack_public_path__ + "img/Honig-aus-2021-920.a921af03.jpg";